import { useState, useEffect } from 'react';
import { getApiUrl, getDefaultHeaders } from '../lib/api';

export const useCAGAvailability = () => {
  const [isCAGAvailable, setIsCAGAvailable] = useState<boolean | 'error' | null>(null);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    let mounted = true;

    const checkCAGAvailability = async () => {
      try {
        const response = await fetch(getApiUrl('/api/cag/health'), {
          headers: getDefaultHeaders(),
        });
        
        if (mounted) {
          // Consider CAG available only if we get a 200 OK response
          // 404 = endpoint doesn't exist, 500 = endpoint exists but failing
          if (response.status === 404) {
            setIsCAGAvailable(false);
          } else if (response.ok) {
            setIsCAGAvailable(true);
          } else {
            // 500 or other errors - CAG endpoint exists but has issues
            setIsCAGAvailable('error');
          }
          setIsChecking(false);
        }
      } catch (error) {
        console.log('CAG health check failed:', error);
        if (mounted) {
          setIsCAGAvailable(false);
          setIsChecking(false);
        }
      }
    };

    checkCAGAvailability();

    return () => {
      mounted = false;
    };
  }, []);

  return { isCAGAvailable, isChecking };
};